export default {
  drawer: null,
  color: "success",
  // image: 'https://wallpaperplay.com/walls/full/3/3/4/173431.jpg'
  //  image: 'https://wallpaperart.net/wp-content/uploads/2019/06/Iphone-Wallpaper-Rosegold-Wallpaper-Pinterest-carriefiter-90s.jpg'
  image:
    "https://www.downgraf.com/wp-content/uploads/2018/11/10-iPhone-Wallpapers-that-Will-Make-Your-Screen-Beautiful-01-005.jpg",
  mini: false,
};
